import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles/index";
import Drawer from "@material-ui/core/Drawer/index";
import Divider from "@material-ui/core/Divider/index";
import CloseIcon from "@material-ui/icons/Close";
import Card from "@material-ui/core/Card/index";
import CardHeader from "@material-ui/core/CardHeader/index";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Alert } from "react-bootstrap";
import { FaCreditCard } from "react-icons/fa"
import { dateConvert } from "../../../../helpers/dateConvert";
import {IoIosPerson} from "react-icons/io"
import {FcCalendar} from "react-icons/fc"
const useStyles = makeStyles({
    list: {
        width: 400,
        height: "100vh",
    },
    card: {
        margin: "30px",
    },
    pointer: {
        cursor: "pointer",
    },
    progresRoot: {
        width: "100%",
        padding: "32px 16px",
    },
    progress: {
        margin: "auto",
        display: "block",
        color: "#231B88",
    },
});

export default function View(props) {
    const { open, onClose, onCardChoose, chooseCardId } = props;
    const [card, setCard] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const { name, number, user, createdAt, employee, status } = card;

    useEffect(() => {
        setIsLoading(true);
        onCardChoose(chooseCardId)
            .then((res) => {
                setCard(res.data);
                setIsLoading(false);
                setIsError(false);
            })
            .catch((err) => {
                setIsLoading(false);
                setIsError(true);
            });
    }, [chooseCardId, onCardChoose]);

    const classes = useStyles();


    const sideList = (side) => (
        <div className={classes.list} role="presentation">
            <div className="col-12 d-flex align-items-center justify-content-between py-4">
                <h1 className="h3 mb-0">Kart detalları</h1>
                <CloseIcon className={classes.pointer} onClick={onClose} />
            </div>
            <Divider className="bg-dark" />

            {isLoading ? (
                <div className={classes.progresRoot}>
                    <CircularProgress className={classes.progress} />
                </div>
            ) : !isLoading && !isError ? (
                <div className="drawer-body">
                    <Card className={classes.card}>
                        <CardHeader
                            title="Ümumi informasiya"
                            className="bg-secondary text-dark h6 p-3"
                            disableTypography
                        />
                        <CardHeader
                            avatar={
                                <SVG
                                    src={toAbsoluteUrl(
                                        "/media/svg/icons/Communication/Address-card.svg"
                                    )}
                                    className="icon-primary"
                                />
                            }
                            title={name ?name:"-"}
                            subheader="Ad"
                            className="p-3"
                        />
                        <CardHeader
                            avatar={
                                <FaCreditCard
                                    className="icon-primary"
                                />
                            }
                            title={number?number:"-"}
                            subheader="Nömrə"
                            className="p-3"
                        />
                        <CardHeader
                            avatar={
                                <
                                IoIosPerson
                                    className="icon-primary"
                                />
                            }
                            title={employee?employee:"-"}
                            subheader="Əməkdaş adı"
                            className="p-3"
                        />
                        <CardHeader
                            avatar={
                                <SVG
                                    src={toAbsoluteUrl(
                                        "/media/svg/icons/Communication/Address-card.svg"
                                    )}
                                    className="icon-primary"
                                />
                            }
                            title={user?user:"-"}
                            subheader="İstifadəçi"
                            className="p-3"
                        />
                        <CardHeader
                            avatar={
                                <FcCalendar
                                    className="icon-primary"
                                />
                            }
                            title={createdAt?dateConvert(createdAt):"-"}
                            subheader="Yaradılma tarixi"
                            className="p-3"
                        />

                        <CardHeader
                            avatar={
                                <SVG
                                    src={toAbsoluteUrl("/media/svg/icons/Code/Lock-circle.svg")}
                                    className="icon-primary"
                                />
                            }
                            title={status === "ACTIVE"
                            ? "Aktive"
                            :  status=== "INACTIVE"
                            ? "Deaktive"
                            : "-"}
                            subheader="Vəziyyət"
                            className="p-3"
                        />
                    </Card>
                </div>
            ) : (
                <div className="p-5">
                    <Alert variant="info">Xəta baş verdi.</Alert>
                </div>
            )}
        </div>
    );

    return (
        <Drawer
            open={open}
            onClose={onClose}
            anchor="right"
            className="drawer--fixed"
        >
            {sideList("right")}
        </Drawer>
    );
}
